import './home.scss';

import MainSlider from '@components/MainSlider/MainSlider';
import MainNextDraw from './MainNextDraw';
import ResultsInPage from './ResultsInPage';
import intToReal from '@helpers/intToReal';
import getPrizesHome from '@services/inventory/getPrizesHome';
import Accordion from '@components/Accordion/Accordion';
import Modal from '../../Modal/Modal';
import UserApi from '../../Api/UserApi.js';

// import '../../BolaoPageFloat/BolaoPageFloat.js';
import '../../News/NewsSlider';

new Vue({
  el: '[data-vue=page-home]',
  components: {
    'main-slider': MainSlider,
    'main-next-draw': MainNextDraw,
    ResultsInPage,
    Accordion,
    Modal
  },
  data () {
    return {
      selectedStep: 1,
      word: 'fácil',
      arrWords: ['fácil', 'seguro', 'prático', 'divertido'],
      selectedWord: 0,
      selectedChar: 0,
      speed: 175,
      prizes: []
    }
  },
  methods: {
    intToReal,
    setStep (step) {
      this.selectedStep = step;
    },
    cleanText () {
      if (this.selectedChar > 0) {
        this.word = this.arrWords[this.selectedWord].slice(
          0,
          this.selectedChar
        );
        this.selectedChar--;

        if (this.selectedChar == 0) {
          this.selectedWord =
            this.selectedWord == this.arrWords.length - 1
              ? 0
              : this.selectedWord + 1;
          setTimeout(() => this.setText(this), 200);
        } else {
          setTimeout(() => this.cleanText(this), 50);
        }
      }
    },
    setText () {
      if (this.selectedChar <= this.arrWords[this.selectedWord].length) {
        this.word = this.arrWords[this.selectedWord].slice(
          0,
          this.selectedChar
        );
        this.selectedChar++;
        setTimeout(() => this.setText(), 200);
      } else {
        setTimeout(() => this.cleanText(), 2000);
      }
    },
    fetchPrizes () {
      getPrizesHome()
        .then(res => {
          this.prizes = res;
        })
        .catch(err => console.error(err))
    },
    fetchUser () {
      UserApi.get()
        .then((user) => {
          if (user && user.incompleteRegistration && !sessionStorage.getItem('modalIncompletRegistration')) {
            sessionStorage.setItem('modalIncompletRegistration', 'true');
            window.Modal.open('COMPLETE_REGISTRATION', {
              userInfo: user
            }, false);
          }
        })
        .catch(() => {})
    }
  },
  created () {
    this.setText();
    this.fetchPrizes();
    this.fetchUser();
  },
  mounted () {
    if (sessionStorage.getItem('Modal') && sessionStorage.getItem('LastStepForgot')) {
      Modal.open('RESET_PASSWORD')
      sessionStorage.removeItem('Modal')
      sessionStorage.removeItem('LastStepForgot')
    }
    if (sessionStorage.getItem('ModalSocialAccount') && sessionStorage.getItem('LastStepForgot')) {
      Modal.open('RESET_SOCIAL_PASSWORD')
      sessionStorage.removeItem('ModalSocialAccount')
      sessionStorage.removeItem('LastStepForgot')
    }
  }
});
